<form [formGroup]="form" (submit)="onSubmit()">
    <div class="d-flex align-items-center">
        <div class="form-group col-3">
            <label class="form-label form-label-required" translate="BenefEffectif.Siren"> </label>
            <input 
                id="field-nom"
                class="form-control"
                type="text"
                formControlName="siren"
                inputRestriction="numericWithwhiteSpace"
                siren
                (keydown.enter)="onSubmit()"
                [class.is-invalid]="sirenField.dirty && sirenField.invalid"
            />
            <form-control-feedback
                [messages]="{
                    MaxLength: maxLengthErrorMessage,
                    ExactLength: maxLengthErrorMessage
                }"
                [field]="sirenField"
            ></form-control-feedback>
        </div>
        <div class="form-group ml-2">
                <button type="submit" aria-label="Search" class="btn btn-primary" style="margin-left: 2em;" 
                    [disabled]="((sirenField?.value?.length || 0) < maxlengthsirenFieldInput) || (loader && loader.isLoading$ | async)" 
                >
                <i class="far fa-search"></i>
                {{ 'Actions.Search' | translate }}
                <loader-button-spinner [isShowButtonSpinner]="loader?.isLoading$ | async"></loader-button-spinner>
            </button>
        </div>
    </div>
</form>
